<template>
  <div class="">
    <!--Filters-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <b-row no-gutters class="w-100">
          <b-col>
            <h5>{{ msg("Filters") }}</h5>
          </b-col>
          <b-col>
            <div class="d-flex justify-content-end">
              <b-link style="color: inherit" @click="refresh()">
                <feather-icon icon="RefreshCcwIcon" size="16"/>
              </b-link>
            </div>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>

          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <label>{{ msg("Client name") }}</label>
            <b-form-input
                v-model="filter.like.clientName"
                class="d-inline-block mr-1"
            />
          </b-col>


          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <b-form-group :label="msg('Event')" label-for="realEstate-branch">
              <v-select
                        :dir="isRTL ? 'rtl' : 'ltr'"
                        :clearable="true"
                        v-model="filter.like.messageEvent"
                        :options="allEvents"
                        class="w-100"
                        label="text"
                        :reduce="(branch) => branch.value"

              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <b-form-group :label="msg('Trigger')" label-for="realEstate-branch">
              <v-select
                        :dir="isRTL ? 'rtl' : 'ltr'"
                        :clearable="true"
                        v-model="filter.like.messageTrigger"
                        :options="allTriggers"
                        class="w-100"
                        label="text"
                        :reduce="(branch) => branch.value"

              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <b-form-group :label="msg('Channel')" label-for="realEstate-branch">
              <v-select
                        :dir="isRTL ? 'rtl' : 'ltr'"
                        :clearable="true"
                        v-model="filter.like.messageChannel"
                        :options="allChannels"
                        class="w-100"
                        label="text"
                        :reduce="(branch) => branch.value"

              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <b-form-group :label="msg('Status')" label-for="realEstate-branch">
              <v-select
                        :dir="isRTL ? 'rtl' : 'ltr'"
                        :clearable="true"
                        v-model="filter.like.status"
                        :options="allStatuses"
                        class="w-100"
                        label="text"
                        :reduce="(branch) => branch.value"

              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group>
              <b-form-checkbox v-model="filter.eq.success" inline>
                {{ msg('Success') }}
              </b-form-checkbox>

            </b-form-group>

          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <div class="card-header" style="overflow: hidden">
        <span class="card-title m-0">{{ msg('Messages history') }}</span>
        <b-col>
          <div class="d-flex justify-content-end">
            <b-link style="color: inherit" @click="refresh()">
              <feather-icon icon="RefreshCcwIcon" size="16"/>
            </b-link>
          </div>
        </b-col>
      </div>
      <!--Card Content-->
      <b-card-body>
        <div class="">
          <!-- Table Top -->
          <b-row no-gutters class="mb-1">
            <!-- Per Page -->
            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ msg('Show') }}</label>
              <v-select
                  v-model="page.amount"
                  @option:selected="refresh"

                  :dir="isRTL ? 'rtl' : 'ltr'"
                  :options="[10, 25, 50, 100,250,500]"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>{{ msg('entries') }}</label>
            </b-col>

          </b-row>

        </div>
        <!--Table-->
        <b-table
            ref="messageTemplate-table"
            striped
            hover
            responsive
            v-bind:items="messageHistory"
            v-bind:fields="fields"
            :busy="loading"
            @sort-changed="onSort"
            @row-clicked="onRowClick"
        >
          <template #cell(id)="data">
            <b-button style="width: 95px" variant="outline-primary"
                      size="sm"
                      v-clipboard:copy="data.value"
                      v-clipboard:success="onCopy"
                      class="d-block">
              <i class="fas fa-copy"> </i> ID
            </b-button>

          </template>
          <template #cell(status)="data" class="p-0">
            <b-badge :variant="statusVariants[data.value]">{{statusNames[data.value]}}</b-badge>
          </template>
          <template #cell(propertyNames)="data">
            <b-button variant="primary" id="property-tooltip" style="font-weight: bold;margin-right: 2px">
              {{ msg('Properties') }}
            </b-button>
            <b-tooltip target="property-tooltip" triggers="click" placement="right">
              <div v-for="property in data.value" :key="property">
                {{ property }}
              </div>
            </b-tooltip>
          </template>
          <template #cell(success)="data">
            <span v-if="data.value" style="color: #00c853"> {{ msg('Yes')}}</span>
            <span v-else style="color: red "> {{ msg('No') }}</span>
          </template>
          <template #cell(messageChannel)="data">
            <span style="font-weight: bold">
              {{ data.value }}
            </span>
          </template>

          <template #cell(contractId)="data">
            <div class="text-capitalize" style="white-space: nowrap">
              <b-button variant="link" @click="openContract(data.item)"
                        class="text-decoration-none text-capitalize m-0 px-1" :title="$t('View Contract')">
                {{ data.item.clientName }}
              </b-button>

            </div>
          </template>


          <template #cell(messageEvent)="data">
            <span style="font-weight: bold">
              {{ data.value.replace(/_/g, ' ') }}
            </span>
          </template>
<template #cell(messageTrigger)="data">
            <span style="font-weight: bold">
              {{ data.value.replace(/_/g, ' ') }}
            </span>
          </template>
          <template #cell(timeToSend)="data">
            <span v-if="(data.item.messageEvent).replace(/_/g, ' ')==='POST BOOKING'">{{ msg('Instant') }}</span>
            <span v-else>
            {{ $moment(data.value, 'YYYY-MM-DD HH:mm').format("DD.MM.YYYY HH:mm") }}
          </span>
          </template>
          <template #cell(sentTime)="data">
            {{ data.value!=null && data.value!=='' ? $moment(data.value, 'YYYY-MM-DD HH:mm').format("DD.MM.YYYY HH:mm") : msg('Not sent yet') }}
          </template>
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mx-1"></b-spinner>
              <strong>{{ msg('Loading') }}...</strong>
            </div>
          </template>

        </b-table>

        <!--Table Paginator-->
        <div class="text-center w-100">
          <div class="d-inline-block">
            <b-pagination
                v-model="page.currentPage"
                :total-rows="page.total"
                :per-page="page.amount"
                first-number
                last-number
                @input="refresh"
            />
          </div>
          <div class="d-inline-block px-2"><strong>{{ msg('Total') }}</strong> {{ page.total }}</div>
        </div>
      </b-card-body>
    </b-card>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'MessageHistory',
  components: {
  },
  data() {
    return {
      loading: true,
      amount: 10,
      messageHistory: [],
      fields: [],
      messageTemplateId: null,

      filter: {
        like: {search: ''},
        eq: {type: ""},
        lte: {},
        gte: {},
        in: {}
      },

      sort: {
        by: 'timeToSend',
        desc: true,
        direction: 'asc'
      },
      statusVariants:
          {"NEW": "primary", "SENT_AUTOMATICALLY": "warning", "SENT_MANUALLY": "warning", "DELETED": "danger"},
      statusNames:
          {"NEW": ("New"), "SENT_AUTOMATICALLY": ("Sent automatically"), "SENT_MANUALLY": ("Sent manually"), "DELETED": ("Deleted")},
      page: {
        amount: 100,
        currentPage: 1,
        total: 0
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },

      //Listeners
      listeners: {
        refresh: () => {
        }
      }

    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.refresh()
      }
    }
  },
  computed: {
    ...mapGetters('data', ['getBranchName']),

    ...mapGetters('data', ['getOrganizationWebSite', 'getRealEstatesWebSite']),
    ...mapGetters('data', ['getUserFullName', 'getUserAcronyms']),
    ...mapGetters('data', ['getAllUsers', 'getUsersInTeam', 'getUserRole', 'getRoles', 'getRoleName']),
    ...mapGetters('translator', ['msg']),
    ...mapGetters('data', ['getAllBranches']),
    ...mapGetters('messageTemplate', ['allStatuse','allEventsList','allTriggersList','allChannelsList']),
    allBranches() {
      return Object.values(this.getAllBranches)
    },
    allStatuses() {
      return Object.values(this.allStatuse)
    },
    isRTL() {
      return this.$i18n.locale === 'ar' || this.$i18n.locale === 'he'
    }
    ,
    allEvents() {
      return Object.values(this.allEventsList);
    },
    allTriggers() {
      return Object.values(this.allTriggersList);
    },

    allChannels() {
      return Object.values(this.allChannelsList);
    },

  },
  created() {
    let $this = this;

    this.setFields();
    this.refresh()
    this.$root.$on('crm::branch-updated', (this.listeners.refresh = () => {
      $this.refresh()
    }))
  },
  beforeDestroy() {
    this.$root.$off('crm::branch-updated', this.listeners.refresh)
  },
  methods: {
    ...mapActions('messageTemplate', ['allHistory','copySuccess']),
    openContract(feature) {
      window.open(`/real_estate/contracts/rent/${feature.contractId}#guest-feature`, '_blank');
    },
    onCopy: function (e) {
      this.copySuccess(e.text)
    },
    setFields() {
      let $this = this
      this.fields = [

        {
          key: 'id',
          label: $this.msg('ID'),
          sortable: true,
          active: true,
        },
        {
          key: 'messageEvent',
          label: $this.msg('Event'),
          sortable: true
        }, {
          key: 'messageTrigger',
          label: $this.msg('Trigger'),
          sortable: true
        },
        {
          key: 'messageChannel',
          label: $this.msg('Channel'),
          sortable: true,
          active: true,
        },
        {
          key: 'status',
          label: $this.msg('status'),
          sortable: true,
          active: true,
        }, {
          key: 'contractId',
          label: $this.msg('Contract'),
          sortable: true,
          active: true,
        },   {
          key: 'timeToSend',
          label: $this.msg('Time to send'),
          sortable: true,
          active: true,
        },{
          key: 'sentTime',
          label: $this.msg('Time sent'),
          sortable: true,
          active: true,
        },
{
          key: 'success',
          label: $this.msg('success'),
          sortable: true,
          active: true,
        },


      ]
    },

    refresh() {
      let $this = this
      this.loading = true;
      this.allHistory({
        page: $this.page.currentPage,
        amount: $this.page.amount,
        filter: $this.filter,
        sortcolumn: 'timeToSend',
        sortby: 'desc',
      }).then(this.onMessageHistoryRetrieve, (error) => $this.error = error)


    },
    onMessageHistoryRetrieve(data) {
      this.page = {
        amount: data['Amount'],
        total: data['Total'],
        currentPage: data['Page']
      };
      this.sort = {
        by: data["sortColumn"],
        direction: data["sortOrder"]
      }
      this.messageHistory = data["MessageHistory"];
      this.loading = false;
    },

    onSort(data) {
      this.sort.by = data.sortBy;
      this.sort.direction = data.sortDesc ? "desc" : "asc";
      this.refresh();
    },
    onRowClick(messageTemplate) {
      console.log("messageTemplate im here", messageTemplate)
      this.selectedTemplate = messageTemplate;
      this.dialogs.messageTemplateUpdate = true;
    },


  }
}
</script>

<style>

</style>
